import React, { useEffect } from "react";
import GModal from "components/ui/modal/Modal";
import { useTranslation } from "react-i18next";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import GButton from "components/ui/button/Button";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getModifiers,
  addModifiersForProduct,
  getModifiersForProduct,
} from "../../services/LinkingModifiersService";

const LinkingModifiersModal = ({ onClose }) => {
  const id = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { handleSubmit, setValue } = useForm();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });

  const toast2 = useToast({
    position: "top",
    duration: 3000,
    status: "error",
  });

  const modifiers = useSelector((state) => state.addModifier);

  useEffect(() => {
    dispatch(getModifiers());
  }, [dispatch]);

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.modifiers_options.add_modifier")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.ModifersId = values.ModifersId?.ModifersId;
              values.ProductId = id.productId;
              values.UserId = localStorage.getItem("userId");

              if (values.ModifersId === undefined) {
                toast2({
                  description: t("pages.DailyRestrictions.searchvalidation"),
                });
              } else {
                dispatch(addModifiersForProduct(values))
                  .unwrap()
                  .then((_) => {
                    toast({ description: "Modifier created" });
                    dispatch(getModifiersForProduct(id.productId));
                    onClose();
                  });
              }
            })}
          >
            <Stack>
              <MultiSelect
                title={t("pages.modifiers.modifiers")}
                data={
                  modifiers.modifiersData &&
                  modifiers.modifiersData.map((el) => ({
                    ...el,
                    label: el.ModifersNameEng,
                    value: el.ModifersId,
                  }))
                }
                isMulti={false}
                isRequired={true}
                onChange={(e) => setValue("ModifersId", e)}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  isLoading={modifiers.isLoading}
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  isLoading={modifiers.isLoading}
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default LinkingModifiersModal;
